export const INDIRECT_INV_KEY_PROJECT = 'project';
export const INDIRECT_INV_KEY_STAGE = 'stageId';
export const INDIRECT_INV_KEY_LOCALE = 'locale';
export const INDIRECT_INV_KEY_PROJ_SUB_ID = 'projectSubId';
export const INDIRECT_INV_KEY_HIRING_MANAGERS = 'hms';

export const INDIRECT_INV_KEYS = [
  INDIRECT_INV_KEY_PROJECT,
  INDIRECT_INV_KEY_STAGE,
  INDIRECT_INV_KEY_LOCALE,
  INDIRECT_INV_KEY_PROJ_SUB_ID,
  INDIRECT_INV_KEY_HIRING_MANAGERS,
];
